import { Model as BaseModel } from 'vue-api-query'

BaseModel.$http = window.axios;

export default class Model extends BaseModel {

    getActiveWorkstation() {
        return window.vm.$store.getters['workstation/getWorkstationId'] || 1
    }

    baseURL() {
        let workstationId = this.getActiveWorkstation()
        return `${window.App.api_endpoint}/api/${workstationId}`
    }

    mediaEndpoint() {
        return `${this.endpoint()}/media`
    }

    _reqConfig(config, options = { forceMethod: false }) {
        if(config?.data?.originalData) {
            delete config.data.originalData
        }
        return super._reqConfig(config, options)
    }

    async request(config)
    {
        return await this.$http.request(config);
    }

    isValidId(id) {
        return id !== undefined && id !== 0 && id !== '' && id !== null && id !== 'null'
    }

    endpoint() {
        if(this._customResource) {
            return `${this.baseURL()}/${this._customResource}`
        } else {
            return super.endpoint()
        }
    }
}
